// Legacy had exactly one cross-app base (`talentUrl`) and pointed every CTA at it — including
// the employer ones. Preserved: one base, build-time env, same pattern as talent-dashboard's
// src/config/env.ts. Default is the talent-dashboard dev port from scripts/dev.mjs.
const defaultTalentAppUrl = 'http://localhost:5274'

export const env = {
  talentAppUrl: import.meta.env.VITE_TALENT_APP_URL || defaultTalentAppUrl,
  /**
   * The two session-less helpers (suggest + locations) live on talent-bff under /api/public. In
   * dev the Vite server proxies `/api` there (vite.config.ts); a deployed build sets the origin.
   */
  apiUrl: import.meta.env.VITE_API_URL || '/api',
} as const
